export const SITE = {
  name: "MHM SUPER ADBLUE",
  phone: "8972136750",
  phoneDisplay: "+91 89721 36750",
  headOffice: "7047854814",
  headOfficeDisplay: "+91 70478 54814",
  email: "mhmsuperadblue@gmail.com",
  location: "Haldia, Purba Medinipur, West Bengal, India",
  mapEmbed: "https://www.google.com/maps?q=Haldia,+Purba+Medinipur,+West+Bengal,+India&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=Haldia,+Purba+Medinipur,+West+Bengal",
};

export const waLink = (text = "Hello MHM SUPER ADBLUE, I would like to enquire about your products.") =>
  `https://wa.me/91${SITE.phone}?text=${encodeURIComponent(text)}`;

export const CATEGORIES = [
  { id: "tata", label: "TATA DEF" },
  { id: "gulf", label: "Gulf AdBlue" },
  { id: "eicher", label: "Eicher AdBlue" },
  { id: "bharatbenz", label: "BharatBenz AdBlue" },
  { id: "buckets", label: "AdBlue Buckets" },
  { id: "ibc", label: "AdBlue IBC Tanks" },
  { id: "lubricants", label: "Lubricating Oils" },
];

export const shopMapsLink = (s) => {
  if (s?.maps_url) return s.maps_url;
  if (typeof s?.lat === "number" && typeof s?.lng === "number")
    return `https://www.google.com/maps/dir/?api=1&destination=${s.lat},${s.lng}`;
  const q = [s?.name, s?.address, s?.area, s?.district, s?.state, s?.pincode].filter(Boolean).join(", ");
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
};

export const catLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label ?? id;

export const formatPrice = (p) =>
  typeof p === "number" && p > 0 ? `₹${p.toLocaleString("en-IN")}` : null;

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/locations", label: "Our Locations" },
  { to: "/bulk-orders", label: "Bulk Orders" },
  { to: "/dealer-franchise", label: "Dealer & Franchise" },
  { to: "/contact", label: "Contact" },
];
